import { format } from 'date-fns';
import { BannerDynamic } from '../Banners/BannerDynamic';

interface BlogHeaderProps {
  title?: string;
  totalArticles?: number;
  banner?: any;
}

export const BlogHeader = ({
  title,
  totalArticles,
  banner,
}: BlogHeaderProps) => {
  return (
    <div className="w-full mb-14 mb:mb-12">
      <div className="flex flex-col md:flex-row items-center md:items-end justify-center md:justify-between border-b border-gray-200 pb-5 lg:pb-6">
        <div className="text-sm text-gray-500 hidden md:block">
          {format(new Date(), 'dd/MM/yyyy')}
        </div>
        <div className="text-5xl font-serif text-center md:-mb-3">{title}</div>
        <div className="text-sm text-gray-500 hidden md:block">
          {totalArticles} articles
        </div>
        <div className="flex w-full justify-between mt-6 md:hidden">
          <div className="text-sm text-gray-500">
            {format(new Date(), 'dd/MM/yyyy')}
          </div>
          <div className="text-sm text-gray-500">{totalArticles} articles</div>
        </div>
      </div>
      {banner && (
        <div className="max-w-6xl w-full mx-auto mt-6">
          <BannerDynamic content={banner} />
        </div>
      )}
    </div>
  );
};
